'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {UiComponent} from '../ui/UiComponent.js';
import {RelativeContainer} from '../ui/RelativeContainer.js';

const privateMap = util.createPrivateMapper();

export class PlaybackViewControl {
  constructor(domEl, argOptions){
    const pv = privateMap(this);
    const options = argOptions ? argOptions : {};

    pv.listeners = {}
    pv.control = null;
    pv.listeners.play = (ev) => {
      if (pv.view) {
        pv.view.requestRender();
        domUtil.dispatchEvent(domEl, 'ui.playback.play', {
          detail: {}
        });
      }
    }
    pv.listeners.pause = (ev) => {
      if (pv.view) {
        domUtil.dispatchEvent(domEl, 'ui.playback.pause', {
          detail: {}
        });
      }
    }
    pv.resetControl = () => {
      if (pv.control) {
        pv.control.stop();
        for (let nm in pv.listeners) {
          pv.control.removeEventListener(nm, pv.listeners[nm]);
        }
      }
      pv.control = null;
    }
    pv.contentChangeHandler = (ev) => {
      const pv = privateMap(this);
      pv.resetControl();
      if (!pv.view) {
        return;
      }
      if (pv.view.control) {
        pv.control = pv.view.control.playback;
        for (let nm in pv.listeners) {
          pv.control.addEventListener(nm, pv.listeners[nm]);
        }
        if (pv.control.playing) {
          domUtil.dispatchEvent(domEl, 'ui.playback.play', {
            detail: {}
          });
        } else {
          domUtil.dispatchEvent(domEl, 'ui.playback.pause', {
            detail: {}
          });
        }
      }
      pv.view.requestRender();
    }

    if (options.playButtonEl) {
      pv.playButtonEl = options.playButtonEl;
      domUtil.addEventListener(pv.playButtonEl, 'click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.play();
      });
    }

    if (options.pauseButtonEl) {
      pv.pauseButtonEl = options.pauseButtonEl;
      domUtil.addEventListener(pv.pauseButtonEl, 'click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        this.pause();
      });
    }

    this.unlink();
  }

  link(view) {
    const pv = privateMap(this);
    if (pv.view) {
      this.unlink();
    }
    pv.view = view;
    if (pv.view) {
      domUtil.addEventListener(pv.view.eventLayer, 'ui.contentchange', pv.contentChangeHandler);
    }
  }

  unlink() {
    const pv = privateMap(this);
    if (pv.playButtonEl) {
      pv.playButtonEl.style.display = 'none';
    }
    if (pv.pauseButtonEl) {
      pv.pauseButtonEl.style.display = 'none';
    }
    
    if (pv.view) {
      pv.resetControl();
      domUtil.removeEventListener(pv.view.eventLayer, 'ui.contentchange', pv.contentChangeHandler);
    }
    pv.view = null;
  }

  play() {
    const pv = privateMap(this);
    if (!pv.view || !pv.control) {
      return;
    }

    pv.control.play();
    pv.view.requestRender();
  }

  pause() {
    const pv = privateMap(this);
    if (!pv.view || !pv.control) {
      return;
    }

    pv.control.pause();
    pv.view.requestRender();
  }
}